<template>
  <v-row>
    <v-col v-if="loading" cols="12" class="text-center">
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-col>
    <template v-else>
      <v-col cols="12">
        <card-title class="pt-0">
          <router-link class="body-2 pl-md-2" :to="{ name: 'downtime' }">
            Back to all incidents
          </router-link>
        </card-title>
      </v-col>
      <v-col cols="12" class="pt-0">
        <gg-card>
          <gg-card-header>
            Details
          </gg-card-header>
          <gg-card-text>
            <v-data-table :headers="headers" :items="downtime" hide-default-footer>
              <template v-slot:item.affected_servers="{ item }">
                <div v-for="(server, i) in item.affected_servers" :key="i">
                  {{ server }}
                </div>
              </template>
              <template v-slot:item.status="{ item }">
                <v-icon small class="mb-1" :color="statusColor(item.status)">
                  mdi-circle
                </v-icon>
                {{ item.status }}
              </template>
            </v-data-table>
          </gg-card-text>
        </gg-card>

      </v-col>
      <v-col cols="12" class="pt-8">
        <h3 class="mb-0">
          Updates
        </h3>
      </v-col>
      <v-col cols="12" v-for="reply in repliesSorted" :key="reply.id">
        <gg-card>
          <gg-card-header>
            <div class="d-flex justify-space-between">
              <div>{{ reply.status }}</div>

              <div class="caption">{{ reply.created_at }}</div>
            </div>

          </gg-card-header>
          <gg-card-text class="text-block" v-html="reply.message" />
        </gg-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import CardTitle from 'Components/Global/GGCardTitle'

export default {
  name: 'DowntimeSingleView',
  components: {
    CardTitle
  },
  data: () => ({
    loading: true,
    downtime: [],
    replies: [],
    headers: [
      {
        text: 'Affected servers',
        value: 'affected_servers'
      },
      {
        text: 'Cause',
        value: 'title'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: 'Created',
        value: 'created_at'
      },
      {
        text: 'Updated',
        value: 'updated_at'
      },
    ],
  }),
  computed: {
    repliesSorted () {
      return this.replies.slice().sort((a, b) => b.id - a.id)
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    ...mapActions({
      getDowntimeEntry: 'downtime/getDowntimeEntry',
      reportError: 'reportError'
    }),
    async getData () {
      try {
        this.loading = true
        const { id } = this.$route.params

        const { downtime, replies } = await this.getDowntimeEntry(id)

        this.downtime.push(downtime)
        this.replies = replies
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    statusColor (status) {
      switch (status) {
        case 'Investigating':
          return 'orange'
        case 'In Progress':
          return 'red'
        case 'Monitoring':
          return 'yellow'
        case 'Resolved':
          return 'green'
        default:
          return 'grey'
      }
    }
  }
}
</script>

<style scoped>
.text-block {
  white-space: pre-line;
}
</style>
